export default __webpack_public_path__ + "static/media/main-peran.e07ec8c1.png";